<template>
<img v-if="value" class="checked-img" @click.stop="change" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/checked.svg" alt="">
<img v-else @click.stop="change" class="checked-img"  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/unchecked.svg" />
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    change () {
      this.$emit('input', !this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.checked-img {
  width: 24px;
  height: 24px;
}
</style>
